var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoElement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 162,
    viewBox: "0 0 163 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.628 24.2969H43.4281C38.9546 24.2969 35.3281 27.9234 35.3281 32.3969V129.597C35.3281 134.07 38.9546 137.697 43.4281 137.697H140.628C145.102 137.697 148.728 134.07 148.728 129.597V32.3969C148.728 27.9234 145.102 24.2969 140.628 24.2969Z",
    fill: "#D6DDF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1768_63797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3156 85.0391H127.666C128.74 85.0391 129.77 85.4658 130.529 86.2253C131.289 86.9848 131.716 88.0149 131.716 89.0891V109.339C131.716 110.413 131.289 111.443 130.529 112.203C129.77 112.962 128.74 113.389 127.666 113.389H18.3156C17.2415 113.389 16.2114 112.962 15.4518 112.203C14.6923 111.443 14.2656 110.413 14.2656 109.339V89.0891C14.2656 88.0149 14.6923 86.9848 15.4518 86.2253C16.2114 85.4658 17.2415 85.0391 18.3156 85.0391V85.0391Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.2556 91.5156H57.1956C55.8536 91.5156 54.7656 92.6036 54.7656 93.9456C54.7656 95.2877 55.8536 96.3756 57.1956 96.3756H78.2556C79.5977 96.3756 80.6856 95.2877 80.6856 93.9456C80.6856 92.6036 79.5977 91.5156 78.2556 91.5156Z",
    fill: "#384B8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M92.8356 102.047H57.1956C55.8536 102.047 54.7656 103.135 54.7656 104.477C54.7656 105.819 55.8536 106.907 57.1956 106.907H92.8356C94.1777 106.907 95.2656 105.819 95.2656 104.477C95.2656 103.135 94.1777 102.047 92.8356 102.047Z",
    fill: "#9CA9D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4372 106.906C32.687 106.906 36.1322 103.46 36.1322 99.2106C36.1322 94.9608 32.687 91.5156 28.4372 91.5156C24.1874 91.5156 20.7422 94.9608 20.7422 99.2106C20.7422 103.46 24.1874 106.906 28.4372 106.906Z",
    fill: "#D6DDF2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1768_63797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.666 48.6016H18.3156C16.0789 48.6016 14.2656 50.4148 14.2656 52.6516V72.9016C14.2656 75.1383 16.0789 76.9516 18.3156 76.9516H127.666C129.902 76.9516 131.716 75.1383 131.716 72.9016V52.6516C131.716 50.4148 129.902 48.6016 127.666 48.6016Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.6306 55.0781H55.5706C54.2286 55.0781 53.1406 56.1661 53.1406 57.5081C53.1406 58.8502 54.2286 59.9381 55.5706 59.9381H76.6306C77.9727 59.9381 79.0606 58.8502 79.0606 57.5081C79.0606 56.1661 77.9727 55.0781 76.6306 55.0781Z",
    fill: "#384B8E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M91.2106 65.6094H55.5706C54.2286 65.6094 53.1406 66.6973 53.1406 68.0394C53.1406 69.3814 54.2286 70.4694 55.5706 70.4694H91.2106C92.5527 70.4694 93.6406 69.3814 93.6406 68.0394C93.6406 66.6973 92.5527 65.6094 91.2106 65.6094Z",
    fill: "#9CA9D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9606 70.4759C43.2105 70.4759 46.6556 67.0308 46.6556 62.7809C46.6556 58.5311 43.2105 55.0859 38.9606 55.0859C34.7108 55.0859 31.2656 58.5311 31.2656 62.7809C31.2656 67.0308 34.7108 70.4759 38.9606 70.4759Z",
    fill: "#D6DDF2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1768_63797",
    x: 9.40562,
    y: 82.6091,
    width: 127.173,
    height: 38.0716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.43
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1768_63797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1768_63797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1768_63797",
    x: 9.40562,
    y: 46.1716,
    width: 127.173,
    height: 38.0716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.43
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1768_63797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1768_63797",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoElement);
export default __webpack_public_path__ + "static/media/noElement.3ecbf7774971befe0f38be4af1503977.svg";
export { ForwardRef as ReactComponent };